import React from "react";
import { Icon } from "@mc/mc-legacy";
import * as PropTypes from "prop-types";
import * as StateInfo from "../api/StateInfo";
import "./SignRequestInfoData.scss";

const RequestDocumentStatusIcon = (props) => {
  const requestDocument: SignRequestDocumentVO = props.requestDocument;
  return (
    <Icon
      icon={StateInfo.getIcon(requestDocument.state)}
      title={StateInfo.getStateCaption(requestDocument)}
      style={{
        color: StateInfo.getColor(requestDocument.state),
      }}
      size={props.size}
    />
  );
};

RequestDocumentStatusIcon.propTypes = {
  requestDocument: PropTypes.object.isRequired,
  size: PropTypes.string,
};
export default RequestDocumentStatusIcon;
